import React, {  useState, useEffect } from "react";
import { getUserList, updateActiveStatus } from "../../../services/user.services";
import {
  CAvatar,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CToaster,
  CButton,
  CFormSelect,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CFormLabel,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPeople, cilPencil, cilPlus, cilSearch } from "@coreui/icons";
import CustomPagination from "../../../components/CustomPagination";
import demoAvatar from "src/assets/images/avatars/avatar.png";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import Switch from "react-switch";
import { getActiveCountryList } from "src/services/country.services";
import { useForm } from "react-hook-form";
import { BsChevronDoubleDown, BsChevronDoubleUp } from "react-icons/bs";
import ReactSelect from "react-select";

const DriverManagementTable = () => {
  // const toaster = Driveref();
  // const [toast, addToast] = useState("");
  const [localDriver, setLocalDriver] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const [activeCountries, setActiveCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(15);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [DriverSelectedStatus, setDriverSelectedStatus] = useState("");
  const [searchedString, setSearchedString] = useState("");
  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);

  const [filterSelectCountry, setFilterSelectCountry] = useState("");

  const { register, reset, getValues, handleSubmit } = useForm({
    defaultValues: {
      name: "",
      email: "",
      designation: "",
      type: "",
      isActive: "",
      employeeCode: "",
    },
  });

  useEffect(() => {
    if (localDriver?.userType === "superAdmin") {
      getActiveCountries();
      getDriverItem(currentPage);
    } else {
      getDriverItem(currentPage);
    }
  }, [selectedCountry, DriverSelectedStatus, currentPage]);

  const getDriverItem = (page, searchData = null) => {
    setIsLoading(true);
    let params = getActiveParams(page, searchData);
    params.type = "driver";
    getUserList(params)
      .then(async (response) => {
        setIsLoading(false);
        setCount(response.count);
        setData(response.data);
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  //get all active countries
  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1, status: true })
      .then((response) => {
        if (response.success && response.data) {
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setActiveCountries(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const handleStatusChange = (checked, id) => {
    const data = {
      isActive: checked,
    };
    toast
      .promise(
        updateActiveStatus(data, id),
        {
          loading: "Loading",
          success: "Status updated Succesfully",
          error: (err) => {
            return err.response &&
              err.response.data &&
              err.response.data.message
              ? err.response.data.message
              : defaultErrorMessage;
          },
        },
        {
          id: "login",
        }
      )
      .then(async (response) => {
        console.log("response", response);
        getDriverItem(currentPage);
      })
      .catch((error) => console.error(error));
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    getDriverItem(newPage);
  };

  const handleChangeStatus = async (value) => {
    setDriverSelectedStatus(value);
    setCurrentPage(1);
  };

  const handleOnInputChangeDriverInfo = (value) => {
    setSearchedString(value);
  };

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      setCurrentPage(1);
      setSelectedCountry(selectedOption);
    } else {
      setSelectedCountry(null);
    }
  };

  const handleFilterCountryChange = (selectedOption) => {
    if (selectedOption) {
      setFilterSelectCountry(selectedOption);
    } else {
      setFilterSelectCountry("");
    }
  };

  const submitSearchButton = () => {
    getDriverItem(1);
  };

  const onFormSubmit = (data) => {
    setCurrentPage(1);
    getDriverItem(1, data);
  };
  const handleReset = () => {
    reset({
      name: "",
      email: "",
      designation: "",
      type: "",
      isActive: "",
      employeeCode: "",
    });
    setSelectedCountry("");
    setCurrentPage(1);
    getDriverItem(1);
  };

  const getActiveParams = (page, searchData) => {
    let params = {
      limit,
      page,
      ...getValues(),
    };
    if (DriverSelectedStatus) {
      params.type = DriverSelectedStatus;
    }
    if (searchedString) {
      params.q = searchedString;
    }
    if (selectedCountry) {
      params.country = selectedCountry.value;
    }
    if (filterSelectCountry) {
      params.country = filterSelectCountry.value;
    }

    if (searchData) {
      params = { ...params, ...searchData };
    }
    return params;
  };

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <div className="position-absolute p-2 top-0 end-0">
            <CButton
              type="button"
              size="sm"
              className="bg-none"
              color="primary"
              onClick={() => setShowAdditionalFields((prev) => !prev)}
            >
              {showAdditionalFields ? (
                <BsChevronDoubleUp size={15} />
              ) : (
                <BsChevronDoubleDown size={15} />
              )}
            </CButton>
          </div>
          <CRow className="mb-4">
            <CCol xs={12} md={3}>
              <CFormLabel>Name</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Type name"
                {...register("name", { required: false })}
              />
            </CCol>
            <CCol xs={12} md={3}>
              <CFormLabel>Email</CFormLabel>
              <CFormInput
                type="email"
                placeholder="Type email"
                {...register("email", { required: false })}
              />
            </CCol>
            <CCol xs={12} md={3}>
              <CFormLabel>Designation</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Type designation"
                {...register("designation", { required: false })}
              />
            </CCol>
            <CCol xs={12} md={3}>
              <CFormLabel>Employee Code</CFormLabel>
              <CFormInput
                type="text"
                placeholder="Type employee code"
                {...register("employeeCode", { required: false })}
              />
            </CCol>
          </CRow>

          <div
            style={{
              maxHeight: showAdditionalFields ? "100%" : "0",
              transition: "max-height 0.5s ease",
            }}
          >
            {showAdditionalFields && (
              <CRow className="mb-4">
                {/* <CCol xs={12} md={3}>
                  <CFormLabel>Driver Type</CFormLabel>
                  <CFormSelect
                    defaultValue={DriverSelectedStatus}
                    id={"priority"}
                    {...register("type", { required: false })}
                  >
                    <option value="">All</option>
                    <option value="superAdmin">Super Admin</option>
                    <option value="admin">Admin</option>
                    <option value="cvit">CVIT</option>
                    <option value="driver">Driver</option>
                    <option value="store">Store</option>
                    <option value="others">Others</option>
                  </CFormSelect>
                </CCol> */}
                <CCol xs={12} md={3}>
                  <CFormLabel>Status</CFormLabel>
                  <CFormSelect
                    defaultValue={DriverSelectedStatus}
                    {...register("isActive", { required: false })}
                  >
                    <option value="">All</option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </CFormSelect>
                </CCol>
                {console.log(localDriver,"localDriver")}
                {localDriver?.userType === "superAdmin" && (
                  <CCol xs={12} md={3}>
                    <CFormLabel>Select Country</CFormLabel>
                    <ReactSelect
                      value={filterSelectCountry}
                      onChange={handleFilterCountryChange}
                      // onInputChange={handleOnInputChangeRoute}
                      placeholder="Select country"
                      options={activeCountries}
                      isClearable={true}
                    />
                  </CCol>
                )}
              </CRow>
            )}
          </div>

          <div className="d-flex justify-content-end mt-3">
            <CButton
              type="submit"
              color="primary"
              className="px-5 py-2 me-3"
              onClick={handleSubmit(onFormSubmit)}
            >
              Submit
            </CButton>
            <CButton
              type="submit"
              className="px-5 py-2 ms-3 btn-oliveGreen"
              onClick={handleReset}
            >
              Reset
            </CButton>
          </div>
        </CCardBody>
      </CCard>
      <CCard className="mb-4">
        <CCardBody>
          <CRow className="justify-content-between">
            <CCol sm={6}>
              <h4 id="traffic" className="card-title mb-0">
                Driver Management - Total: {count}
              </h4>
            </CCol>
            <CCol sm={6} className="d-none d-md-flex  justify-content-end">
              <div className="container-fluid px-0">
                <div className="row">
                  <CCol xs={ 9}>
                    <CInputGroup className="mb-3">
                      <CFormInput
                        placeholder="Search Driver name, email, designation, employee code..."
                        onInput={(e) =>
                          handleOnInputChangeDriverInfo(e.target.value)
                        }
                      />
                      <CInputGroupText>
                        <CIcon
                          icon={cilSearch}
                          onClick={submitSearchButton}
                          style={{ cursor: "pointer" }}
                        />
                      </CInputGroupText>
                    </CInputGroup>
                  </CCol>
                  {localDriver?.userType === "superAdmin" && (
                    <CCol xs={3}>
                      <ReactSelect
                        value={selectedCountry}
                        onChange={handleCountryChange}
                        // onInputChange={handleOnInputChangeRoute}
                        placeholder="Select country"
                        options={activeCountries}
                        isClearable={true}
                      />
                    </CCol>
                  )}
                  {/* <CCol xs={2}>
                    <CFormSelect
                      defaultValue={DriverSelectedStatus}
                      id={"priority"}
                      onChange={(e) => handleChangeStatus(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value="superAdmin">Super Admin</option>
                      <option value="admin">Admin</option>
                      <option value="cvit">CDT</option>
                      <option value="driver">Driver</option>
                      <option value="store">Store</option>
                      <option value="others">Others</option>
                    </CFormSelect>
                  </CCol> */}
                  <CCol xs={3}>
                    <Link to="/create-driver">
                      <CButton style={{ width: "100%" }}>
                        <CIcon icon={cilPlus} />
                        &nbsp; Create
                      </CButton>
                    </Link>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
          <CTable
            align="middle"
            className="mb-0 border text-center"
            hover
            responsive
          >
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">
                  Active Status
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Action
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Name
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Email
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Designation
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Employee Code
                </CTableHeaderCell>
                {/* <CTableHeaderCell className="text-center">
                  Driver Type
                </CTableHeaderCell> */}
                <CTableHeaderCell className="text-center">
                  Location / Tag ID
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="9">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="9">No data available</CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell>
                      <Switch
                        onChange={(checked, id) =>
                          handleStatusChange(checked, item._id)
                        }
                        checked={item.isActive}
                      />
                    </CTableDataCell>
                    <CTableDataCell>
                      <Link to={`/edit-driver/${item._id}`}>
                        <CButton color="secondary" style={{ color: "white" }}>
                          <FaEdit />
                        </CButton>
                      </Link>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CAvatar
                        size="md"
                        src={item.avatar ? item.avatar : demoAvatar}
                        status="success"
                      />
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      <div>
                        {item?.DriverType?.type === "store"
                          ? `${item?.lastName}`
                          : `${item?.firstName} ${item?.lastName}`}
                      </div>
                    </CTableDataCell>
                    <CTableDataCell>{item.email}</CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.designation}
                    </CTableDataCell>
                    <CTableDataCell>{item.employeeCode}</CTableDataCell>
                    {/* <CTableDataCell className="text-capitalize">
                      {item.DriverType?.name}
                    </CTableDataCell> */}
                    <CTableDataCell className="text-capitalize">
                      {item?.location?.name}
                      {item?.tagId}
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>

      {/* <CToaster ref={toaster} push={toast} placement="top-end" /> */}
    </>
  );
};

export default DriverManagementTable;
